<template>
    <div>
        <v-dialog v-model="showDialog" max-width="500">
            <v-card>
            <v-card-title class="headline">{{msg}}</v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="indigo white--text" depressed @click="showDialog = false">Ok</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="spacyemailsitem">
            
            <v-list-item-content class="spacyemailsitem__1" :id="getHoverId" @click.prevent="useId()">{{email.muid}}</v-list-item-content>
           
            <v-list-item-content class="spacyemailsitem__2">
                <p ref="email__subject" class="emailsitem__2--subject">
                    <span @click.prevent="showEmail(getId())">{{formatString(email.email_subject)}}  </span>
                  
                </p>
            </v-list-item-content>
             <v-list-item-content class="spacyemailsitem__3">
                <span class="text-left">{{formatString(email.email_from_one)}}</span>
                <span class="text-left">{{getCompetiId()}}</span>
            </v-list-item-content>
            <v-list-item-content class="spacyemailsitem__4">
                {{formatDate(email.email_date)}}
            </v-list-item-content>

          
            <v-list-item-content class="spacyemailsitem__5">
               <v-icon id="icon_style" @click="openPopUp()"  data-inline="true" title="View HTML">mdi-eye</v-icon>
               <v-icon id="icon_style" @click="openCompanyPopUp()" data-inline="true" title="View Predictions">mdi-alpha-p-box</v-icon>
  
            </v-list-item-content>
            
        </div>
        <v-divider/>
    </div>
</template>

<script>
import moment from 'moment'
import 'moment-timezone'
import _ from 'lodash'
import arrow from '@/assets/img/arrow.gif'
export default {
    name: 'EmailsItem',
    data: () => ({
        readClass: "",
        isSettingUp: false,
        arrow: arrow,
        checkedthis: false,
        showDialog: false,
        msg: ''
    }),
    props: [
        'email',
        'isallchecked',
    ],
    mounted() {
        var view = this, e = view.email
        view.$refs.email__subject.id = parseInt(e.email_read) === parseInt(0) ? "unread" : ""
        for (var i = 1; i < 5; i++) {
            if ('emailsitem__' + i in this.$refs) {
                view.$refs['emailsitem__' + i].$refs.input.style.display = 'none'
            }
        }
        view.checkedthis = view.$store.getters['Emails/getAllChecked'] || e.muid === view.$store.getters['Emails/getCheckedByMuid'](e.muid)
        if (e.deleted === 3) {
            e.alreadycopied = true
        }
    },
    computed: {
        getHoverId: function() {
            return this.email.deleted === 1 ? 'hover_id' : ''
        },
        allFlags: function() {
            return this.$store.getters['RawData/getAllFlags']
        },
        flags: function () {
            return JSON.parse(window.localStorage.getItem('rawData')).flags;
        },
        scores: function() {
            return this.$store.getters['RawData/getAllScores']
        },
        allstatus: function() {
            return this.$store.getters['RawData/getAllStatus']
        },
        readStatus: function() {
            return this.$store.getters['RawData/getReadUnRead']
        },
        updateFlag: {
            get: function () {
                return this.email.panelist_core
            },
            set: function (value) {
                this.email.panelist_core = value
                this.$store.dispatch('Emails/updateFlagByMuid', {muid: this.email.muid, panelist_core: value})
            }
        },
        updatePoints: {
            get: function() {
                return this.email.panelist_score
            },
            set: function(value) {
                this.email.panelist_score = value
                this.$store.dispatch('Emails/updatePointsByMuid', {muid: this.email.muid, panelist_score: value})
            }
        },
        updateStatus: {
            set: function(value) {
                this.email.deleted = value
                this.$store.dispatch('Emails/updateStatusByMuid', {muid: this.email.muid, deleted: value})
            },
            get: function() {
                return this.getThisStatus()
            }
        },
        updateMark: {
            set: function(value) {
                this.email.email_read = value
                this.$store.dispatch('Emails/updateMarkByMuid', {muid: this.email.muid, email_read: value})
            },
            get: function () {
                return { text: parseInt(this.email.email_read) === 0 ? 'Unread' : 'Read', value: parseInt(this.email.email_read) }
            }
        },
    },
    methods: {
        useId: function() {
            var view = this
            if (view.email.deleted === 1) {
                view.$fetch({
                    url: view.$url('ASSIGN_COPY'),
                    type: 'POST',
                    data: JSON.stringify({
                        panelist_id: view.email.panelist_id
                    }),
                    contentType: "application/json"
                },{
                operation: 'add',
                vueScope: view
            }).then(function(response) {
                    if (response === null) {
                        view.showDialog = true
                        view.msg = 'No entryID against panelist.'
                    } else if ('entryID' in response) {
                        view.$store.dispatch('Emails/setProductId', response.entryID)
                    }
                })
            }
        },
        openPopUp: function() {
            var view = this
            window.open(
                view.$url('RENDER_HTML') + view.email.muid,
                'emailbodypopup',
                'width=800,height=500'
            )
            window.focus()
        },
        openCompanyPopUp: function() {
            var view = this
            window.open(
                view.$url('RENDER_COMPANY') + view.email.muid,
                'emailbodypopup2',
                'width=800,height=500'
            )
            window.focus()
        },
        status: function(read) {
            return read === 0 ? "Unseen" : "Seen"
        },
        showEmail: function (e) {
            var view = this
            view.email.email_read = 1
            view.$fetch({
                url: view.$url('EMAILS'),
                type: "POST",
                data: JSON.stringify([{
                    muid: view.email.muid,
                    deleted: view.email.deleted,
                    panelist_core: view.email.panelist_core,
                    panelist_score: view.email.panelist_score,
                    email_read: view.email.email_read,
                    index_name: this.email.index_name,
                }]),
                contentType: "application/json",
            },{
                operation: 'add',
                vueScope: view
            }).then(function (response) {
                if (typeof response.status !== 'undefined' && response.status === 'ok') {
                    view.$store.dispatch('Emails/updateMark', view.email).then(function() {
                        view.$refs.email__subject.id = ''
                        view.$refs.email__subject.id = parseInt(view.email.email_read) === parseInt(0) ? 'unread' : 'classa_de_reading'
                    })
                }
            }).catch(function (e) {
                console.log(e)
            });
            this.$router.push({path: '/email/' + e, params: {e}})
        },
        getId: function() {
            return this.email.muid
        },
        formatDate: function (d) {
            if (this.$store.getters['Search/getIsFromSearch']) {
                
                return moment.unix(d).tz("UTC").format('MM/DD/YYYY hh:mm:ss a').toUpperCase()
            }
            return moment.unix(d).tz("UTC").format('MM/DD/YYYY hh:mm:ss a').toUpperCase()
        },
        getThisStatus: function() {
            var view = this
            let obj = _.find(view.allstatus, function(o) {
                return parseInt(o.value) === parseInt(view.email.deleted)
            })
            if (typeof obj === 'undefined') {
                return { text: '', value: '' }
            }
            return { text: obj.text, value: parseInt(view.email.deleted) }
        },
        formatString: (str) => {
            str = str.replace(/[\\_]/g,'')
            str = str.replace(/[//_]/g,'')
            return str
        },
        emailSubject: function(s) {
            if (s.length > 60) {
                s = s.substring(0, 60)
                s = s + " . . ."
            }
            return s
        },
        checkThisEmail: function(v) {
            this.checkedthis = v
        },
        getCompetiId: function() {
            var view = this,
                competi_ids = view.$store.getters['Emails/getCompetiIds'],
                obj = competi_ids.find(e => e.muid === view.email.muid)
            return typeof obj === 'undefined' ? '' : obj.competi_id
        }
    },
    watch: {
        checkedthis: function(o) {
            var view = this
            if (o === true) {
                view.$store.dispatch('Emails/setUpdateObjects', {
                    muid: view.email.muid,
                    deleted: view.email.deleted,
                    panelist_core: view.email.panelist_core,
                    panelist_score: view.email.panelist_score,
                    email_read: view.email.email_read,
                    index_name: view.email.index_name,
                    alreadycopied: 'alreadycopied' in view.email ? view.email.alreadycopied : false,
                    panelist_id: view.email.panelist_id
                })
            } else {
                view.$store.dispatch('Emails/setUpdateAll', false).then(function() {
                    return view.$store.dispatch('Emails/removeObjByMuid', view.email.muid)
                })
            }
        }
    }
}
</script>
<style lang="sass" scoped>
    @import "./../assets/sass/spaceyemailsitem.sass"
</style>